module.exports = __webpack_public_path__ + "img/hjd.e20887dc.png";